$(document).ready(function () {

  // Hide all accordion bodies
  $('.cstm-collaspsible-row .cstm-collaspsible-body').hide();

  // Click handler
  $('.cstm-collaspsible-row-btn').on('click', function () {

    var $row = $(this).closest('.cstm-collaspsible-row');
    var $body = $row.find('.cstm-collaspsible-body');

    // If already active → close
    if ($row.hasClass('active')) {
      $row.removeClass('active');
      $body.stop(true, true).slideUp(300);
    } else {

      // Close all others
      $('.cstm-collaspsible-row.active')
        .removeClass('active')
        .find('.cstm-collaspsible-body')
        .stop(true, true)
        .slideUp(300);

      // Open clicked
      $row.addClass('active');
      $body.stop(true, true).slideDown(300);
    }
  });

});
